import React from 'react';
import {Card, Row, Col} from "tea-component";
import {useIntl} from "umi";
import ChartSvg from '@/pages/datalab/assets/svg/chart.svg';
import DashboardSvg from '@/pages/datalab/assets/svg/dashboard.svg';
import TablesSvg from '@/pages/datalab/assets/svg/tables.svg';
import UserGroupSvg from '@/pages/datalab/assets/svg/user-group.svg';
import {DATALAB_EDITOR} from '@dbl/core/global';


const QuickAnalysis = ({ privilegesLink }: {privilegesLink: (path: string, privileges: string[]) => void;}) => {
  const {formatMessage} = useIntl();
  const cardInfos = [
    {
      key: 'dashboard',
      icon: DashboardSvg,
      title: formatMessage({id: 'dbl_home_dashboard'}),
      desc: formatMessage({id: 'dbl_home_dashboard_desc'}),
      privileges: [DATALAB_EDITOR.Dashbord],
      path: '/WorkBench/MyDashboard'
    },
    {
      key: 'chart',
      icon: ChartSvg,
      title: formatMessage({id: 'dbl_home_chart'}),
      desc: formatMessage({id: 'dbl_home_chart_desc'}),
      privileges: [DATALAB_EDITOR.Chart],
      path: '/WorkBench/MyAnalysis'
    },
    {
      key: 'tables',
      icon: TablesSvg,
      title: formatMessage({id: 'dbl_home_tables'}),
      desc: formatMessage({id: 'dbl_home_tables_desc'}),
      privileges: [DATALAB_EDITOR.Chart, DATALAB_EDITOR.Dataset],
      path: '/DataManagement/SheetManagement'
    },
    {
      key: 'userGroup',
      icon: UserGroupSvg,
      title: formatMessage({id: 'dbl_home_user_group'}),
      desc: formatMessage({id: 'dbl_home_user_group_desc'}),
      privileges: [DATALAB_EDITOR.Chart],
      path: '/DataManagement/UserPackagesManagement'
    },
  ];
  return (<Card>
    <Card.Body title={formatMessage({id: 'dbl_home_quick_analysis'})} className={'dbl-home-quick-body'}>
      <Row>
        {
          cardInfos.map(info => (<Col key={info.key} span={6}>
            <div onClick={() => privilegesLink(info.path, info.privileges)}>
              <Card
                className={'dbl-home-quick-body-card'}
              >
                <Card.Body>
                  <img className={'dbl-home-quick-body-card-img'} src={info.icon} alt=""/>
                  <div>
                    <p className={'dbl-home-quick-body-card-title'}>{info.title}</p>
                    <p className={'dbl-home-quick-body-card-desc'}>{info.desc}</p>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>))
        }
        
      </Row>
    </Card.Body>
  </Card>);

};

export default React.memo(QuickAnalysis);